<template>
  <section class="feature_product_area">
    <div class="header-sec-link">
      <a
        href=""
        class="custom-scroll-links"
        @click.prevent
      ><i class="fas fa-angle-double-down" /></a>
    </div>
    <div class="main_box flex-column w-100">
      <div class="container search__area">
        <!--searchbar-->
        <div class="main_title row">
          <form
            v-if="false"
            action=""
            method="get"
            class="d-flex col-12 ng-pristine ng-valid"
            role="search"
          >
            <div class="form-outline">
              <input
                id="searchArea"
                name="search"
                type="search"
                class="form-control"
              >
              <label
                class="form-label"
                for="searchArea"
                style="margin-left: 0px"
              >Search for your Future Pets</label>
              <div class="form-notch">
                <div
                  class="form-notch-leading"
                  style="width: 9px"
                />
                <div
                  class="form-notch-middle"
                  style="width: 140.8px"
                />
                <div class="form-notch-trailing" />
              </div>
            </div>
            <button
              class="btn mx-2"
              type="submit"
            >
              Search
            </button>
          </form>
        </div>
        <!--searchbar ends-->

        <!-- Kategori Buton Menu -->

        <div class="msifir d-flex justify-content-center w-100 mx-auto mt-4">
          <ul
            class="search-title-tab-list justify-content-center w-100"
            style="padding: 0; margin: 0 auto;"
          >
            <li>
              <router-link
                to="/pets/?category=Cats&sort=newest"
                title="Cats"
                class="btn-search"
              >
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fimg%2Fcat-mini.gif?alt=media"
                  width="60"
                  height="60"
                  decoding="async"
                  alt=""
                >
                <span>Cats</span>
              </router-link>
            </li>
            <li>
              <router-link
                to="/pets/?category=Dogs&sort=newest"
                title="Dogs"
                class="btn-search"
              >
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fimg%2Fezgif-3-db6de49099.gif?alt=media"
                  width="60"
                  height="60"
                  decoding="async"
                  alt=""
                >
                <span>Dogs</span>
              </router-link>
            </li>

            <li>
              <router-link
                to="/pets/?category=Fishes&sort=newest"
                title="Fishes"
                class="btn-search"
              >
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fimg%2Ffish.gif?alt=media"
                  width="60"
                  height="60"
                  decoding="async"
                  alt=""
                >
                <span>Fishes</span>
              </router-link>
            </li>

            <li>
              <router-link
                to="/pets/?category=Reptiles&sort=newest"
                title="Reptiles"
                class="btn-search"
              >
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fimg%2Freptile.gif?alt=media"
                  width="60"
                  height="60"
                  decoding="async"
                  alt=""
                >
                <span>Reptiles</span>
              </router-link>
            </li>

            <li>
              <router-link
                to="/pets"
                title="Pets"
                class="btn-search"
              >
                <span class="search-title-tab-list__new-badge red-bg">NEW</span>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fimg%2Fshop.gif?alt=media"
                  width="60"
                  height="60"
                  decoding="async"
                  alt=""
                >
                <span>Shop</span>
              </router-link>
            </li>

            <li>
              <router-link
                to="/services/"
                title="Services"
                class="btn-search"
              >
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fimg%2Fservice.gif?alt=media"
                  width="60"
                  height="60"
                  decoding="async"
                  alt=""
                >
                <span>Services</span>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- Kategori Buton Menu Sonu -->
      </div>
      <!--Search Results-->
      <div class="container homesearch">
        <div class="row" />
      </div>
      <!--Search Results Sonu-->
    </div>
  </section>
</template>

<script setup>
  /* eslint-disable */
  import { useRoute } from 'vue-router';
  const route = useRoute();
</script>
